import { eventChannel } from 'redux-saga';
import { all, call, fork, put, select, take } from 'redux-saga/effects';
import { putJSON } from '../../util';


export function documentChannel() {
    /* global $tarot */
    return eventChannel(emit => {
        $(document).on('logged-in logged-out', () => {
            emit($tarot.user.getData());
        });
        return () => {
            $(document).off('logged-in logged-out');
        };
    });
}

export function* watchDocumentEvents() {
    const channel = documentChannel();
    while (true) {
        const user = yield take(channel);
        yield put({ type: 'user:update', payload: user });
    }
}

export function* watchLogin() {
    while (true) {
        const action = yield take('user:login');
        try {
            yield call(putJSON, '/api/user/login', action.payload);
        } catch (e) {
            const response = JSON.parse(e.responseText);
            if (response.error_code === 'member not found') {
                yield all([
                    put({
                        type: 'user:update',
                        payload: {
                            email: action.payload.email,
                            password: action.payload.password,
                        },
                    }),
                    put({ type: 'route:to', payload: 'signup' }),
                ]);
                continue;
            } else if (e.status === 400) {
                yield put({ type: 'user:update', payload: { passwordError: true } });
                continue;
            } else {
                yield put({ type: 'route:to', payload: '' });
            }
        }
        yield put({type: 'user:refresh'});
    }
}

export function* watchLoggedIn(path) {
    if (path === '/signup' || path === '/login') {
        yield take('user:logged-in');
        yield put({ type: 'location:href', payload: '/' });
    } else if (path.match(/^\/forums\//)) {
        yield take('user:logged-in');
        let user = yield select(state => state.user);
        let forums_url = yield select(state => state.forums.host);
        if ('forum_name' in user && user.forum_name) {
            yield put({ type: 'location:href', payload: forums_url });
        } else {
            yield put({ type: 'location:href', payload: '/forums/register' });
        }
    }
}

export function* watchLoggedOut(path) {
    if (path === '/checkout') {
        yield take('user:logged-out');
        yield put({ type: 'location:href', payload: '/readings-reports' });
    } else if (path.match(/^\/member\//)) {
        yield take('user:logged-out');
        yield put({ type: 'location:href', payload: '/' });
    }
}


export function* root() {
    yield all([
        fork(watchDocumentEvents),
        fork(watchLogin),
        fork(watchLoggedIn, window.location.pathname),
        fork(watchLoggedOut, window.location.pathname),
    ]);
}



// WEBPACK FOOTER //
// ./app/sagas/user/login.js